import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCCheckbox from '@/Atoms/CCCheckbox';
import CCText from '@/Atoms/CCText';
import CCTextInput from '@/Atoms/CCTextInput';
import ChipList from '@/Atoms/ChipList/ChipList';
import Divider from '@/Atoms/Divider/Divider';
import CCColors from '@/Utils/CCColors';
import {GENDER_TYPE} from '@/Utils/Constants';
import {FontSizes, hs, vs} from '@/Utils/Dimensions';
import React, {useState} from 'react';
import {StyleSheet} from 'react-native';
import {styles} from './styles';
import CCDatePicker from '@/Atoms/CCDatePicker';
import logo from '../../Assets/Images/Svgs/cc_logo.png';
import chesscom from '../../Assets/Images/Svgs/chessdotcom.svg';
import lichess from '../../Assets/Images/Svgs/lichess.svg';
import {formatDateToDDMMYYYY} from '@/Utils/CommonUtils';
import SlideModal from '@/Atoms/SlideModal';
import {PopUp} from '../Visualisation/components/LevelModal';
import ConditionalRender from '@/Atoms/ConditionalRender';

interface OnboardingFormProps {
  isMobileOrTab: boolean;
  beginnerCheck: boolean;
  setBeginnerCheck: (value: boolean) => void;
  setShowPlatforms: (value: boolean) => void;
  showplatforms: boolean;
  handleOnboardingDataChange: (text: string, key: string) => void;
  handleCompleteUserDetails?: (key: string, value: string) => void;
  doGamesImport: () => void;
  dateOfBirth?: Date | null;
  isError: boolean;
  errorMsg: string;
}

const BeginnerOnboarding: React.FC<OnboardingFormProps> = ({
  isMobileOrTab,
  beginnerCheck,
  setBeginnerCheck,
  setShowPlatforms,
  showplatforms,
  handleOnboardingDataChange,
  handleCompleteUserDetails,
  doGamesImport,
  dateOfBirth,
  isError,
  errorMsg,
}) => {
  const [selectedGender, setSelectedGender] = useState([]);
  const [lic, setLIC] = useState('');
  const [cdc, setCDC] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  return (
    <Box
      flexDirection="column"
      style={{width: '100%', alignItems: 'flex-start', marginTop: '10%'}}>
      <img
        src={logo}
        alt="Circlechess"
        style={{
          height: 48,
        }}
      />
      <Box>
        <CCText
          fontSize={FontSizes[24]}
          fontWeight={500}
          style={{alignItems: 'flex-start', marginTop: '10%'}}
          color={CCColors.menuBackground.main}>
          Welcome to CircleChess
        </CCText>
      </Box>
      {/* <CCText
        fontSize={FontSizes[16]}
        style={{
          width: '60%',
          marginTop: '2%',
        }}>
        Help us help you. Connect your Chess.com and Lichess accounts with
        Circlechess.
      </CCText> */}

      <Box
        flexDirection="column"
        style={{width: isMobileOrTab ? '60%' : '100%', marginTop: '2%'}}>
        <Box
          gap={'5%'}
          flexDirection={isMobileOrTab ? 'column' : 'row'}
          style={{}}>
          <Box
            flexDirection="column"
            alignItems="flex-start"
            gap={10}
            style={{paddingTop: vs(10)}}>
            <CCText fontWeight={500} fontSize={FontSizes[14]}>
              Player Name
            </CCText>
            <CCTextInput
              placeholder="Enter player name"
              style={{
                borderColor: CCColors.OnboardingGrey,
                borderWidth: 1,
              }}
              outlineColor={CCColors.OnboardingGrey}
              onChangeText={(text: string) => {
                handleOnboardingDataChange(text, 'name');
              }}
            />
          </Box>
          <Box
            flexDirection="column"
            alignItems="flex-start"
            gap={10}
            style={{paddingTop: vs(10)}}>
            <CCText fontWeight={500} fontSize={FontSizes[14]}>
              Date of Birth
            </CCText>

            <CCDatePicker
              onChange={(text: string) => {
                handleOnboardingDataChange(formatDateToDDMMYYYY(text), 'dob');
              }}
              value={dateOfBirth}
              customize={true}
              customStyle={styles.inputStyling}
              isMobileOrTab={isMobileOrTab}
              minAge={2}
            />
          </Box>
        </Box>
        <Box
          gap={'5%'}
          flexDirection={isMobileOrTab ? 'column' : 'row'}
          style={{marginTop: '3%'}}>
          <Box
            flexDirection="column"
            alignItems="flex-start"
            gap={10}
            style={{paddingTop: vs(10)}}>
            <CCText fontWeight={500} fontSize={FontSizes[14]}>
              Username
            </CCText>
            <CCTextInput
              placeholder="Enter unique username"
              style={{
                borderColor: CCColors.OnboardingGrey,
                borderWidth: 1,
              }}
              outlineColor={CCColors.OnboardingGrey}
              onChangeText={(text: string) => {
                handleOnboardingDataChange(text, 'ccUser');
              }}
            />
          </Box>
          <Box
            flexDirection="column"
            alignItems="flex-start"
            gap={10}
            style={{paddingTop: vs(10)}}>
            <CCText fontWeight={500} fontSize={FontSizes[14]}>
              Email Address
            </CCText>
            <CCTextInput
              placeholder="Enter email address"
              style={{
                borderColor: CCColors.OnboardingGrey,
                borderWidth: 1,
              }}
              outlineColor={CCColors.OnboardingGrey}
              onChangeText={(text: string) => {
                handleOnboardingDataChange(text, 'userEmail');
              }}
            />
          </Box>
        </Box>
        <Box gap={'5%'} flexDirection="row" style={{marginTop: '3%'}}>
          <Box
            flexDirection="column"
            alignItems="flex-start"
            gap={10}
            style={{paddingTop: vs(10)}}>
            <CCText fontWeight={500} fontSize={FontSizes[14]}>
              Select Gender
            </CCText>
            <ChipList
              chipBackgroundColor={CCColors.Primary.lightBrown}
              type={1}
              // onChange={text => ()}
              onChange={(text: string) => {
                handleOnboardingDataChange(text?.key, 'gender');
                setSelectedGender(text);
              }}
              options={GENDER_TYPE}
              value={selectedGender}
            />
          </Box>
        </Box>
      </Box>
      <Divider
        style={{
          width: '60%',
          height: StyleSheet.hairlineWidth,
          marginVertical: '4%',
        }}
        width={1}
      />
      <CCCheckbox
        label={
          <CCText fontSize={FontSizes[14]}>
            I want to link chess.com and lichess account
          </CCText>
        }
        value={showplatforms}
        onValueChange={(label, newValue) => {
          // Handle checkbox state change

          setShowPlatforms(newValue);
        }}
        customStyle={{
          flexDirection: 'row',
          alignItems: 'center',
          marginVertical: 4,
        }}
      />
      {showplatforms ? (
        <Box flexDirection="column" style={{width: '60%'}}>
          <Box
            flexDirection="row"
            alignItems="center"
            style={{paddingTop: vs(12)}}>
            <CCTextInput
              placeholder="Enter your Lichess username"
              style={{borderColor: CCColors.OnboardingGrey, borderWidth: 1}}
              outlineColor={CCColors.OnboardingGrey}
              staticPrefix={
                <>
                  <img src={lichess} />
                </>
              }
              onChangeText={(text: string) => {
                handleOnboardingDataChange(text, 'lichessUser');
                setLIC(text);
              }}
            />
          </Box>
          <Box
            flexDirection="row"
            alignItems="center"
            style={{paddingTop: vs(12)}}>
            <CCTextInput
              placeholder="Enter your Chess.com username"
              style={{
                borderColor: CCColors.OnboardingGrey,
                borderWidth: 1,
              }}
              outlineColor={CCColors.OnboardingGrey}
              staticPrefix={
                <>
                  <img src={chesscom} />
                </>
              }
              onChangeText={(text: string) => {
                handleOnboardingDataChange(text, 'chessdotcomUser');
                setCDC(text);
              }}
            />
          </Box>
          {showPopup && (
            <SlideModal
              visible={showPopup}
              type="center"
              customStyle={styles.levelModalCustom}>
              <PopUp
                confirm={() => setShowPopup(false)}
                text={`By granting CircleChess access to your chess.com or lichess.org account, you give explicit permission to retrieve and use data from your last 100 games for analysis and services offered by CircleChess. You acknowledge full responsibility for granting this access and agree to indemnify CircleChess against any claims, damages, or consequences arising from this data usage. CircleChess will use your data solely for its intended features and will not share it with unauthorized third parties. You confirm that you have the legal right to share this data and that this permission complies with chess.com's or lichess.org's policies respectively. You may revoke this permission at any time, but data already accessed will not be retroactively deleted.
          
`}
                gap={5}
                fontSize={15}
                buttonConfirm="Okay"
              />
            </SlideModal>
          )}
          <CCCheckbox
            label={
              <>
                <CCText fontSize={FontSizes[14]}>
                  I have read and agree to the{' '}
                  <span
                    style={{
                      color: 'blue',
                      textDecorationLine: 'underline',
                    }}>
                    terms and conditions.
                  </span>
                </CCText>
              </>
            }
            value={beginnerCheck}
            onValueChange={(label, newValue) => {
              // Handle checkbox state change
              setBeginnerCheck(newValue);
            }}
            customStyle={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 8,
              marginTop: 10,
            }}
            tickSize={14}
            onLabelPress={() => setShowPopup(true)}
          />
          <ConditionalRender
            condition={isError}
            childrenA={
              <CCText
                style={{
                  flex: 0.1,
                  color: 'red',
                }}>
                {errorMsg}
              </CCText>
            }
            childrenB={<></>}
          />
          <Box
            style={{
              width: 150,
            }}>
            <CCButton
              contentContainerStyle={{
                paddingVertical: vs(10),
                paddingHorizontal: 0,
              }}
              onPress={doGamesImport}
              style={{
                marginTop: '10%',
                marginBottom: 80,
              }}
              disabled={!cdc && !lic}>
              <CCText
                color={
                  !cdc && !lic
                    ? CCColors.TextColor.GreyText
                    : CCColors.Primary.Dark
                }>
                Submit Player
              </CCText>
            </CCButton>
          </Box>
        </Box>
      ) : (
        <>
          <ConditionalRender
            condition={isError}
            childrenA={
              <CCText
                style={{
                  flex: 0.1,
                  color: 'red',
                }}>
                {errorMsg}
              </CCText>
            }
            childrenB={<></>}
          />
          <Box
            style={{
              width: 150,
            }}>
            <CCButton
              contentContainerStyle={{
                paddingVertical: vs(10),
                paddingHorizontal: 0,
              }}
              onPress={doGamesImport}
              style={{
                marginTop: '10%',
                marginBottom: 80,
              }}>
              <CCText color={CCColors.Primary.Dark}>Submit Player</CCText>
            </CCButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default BeginnerOnboarding;
